import { inferUserCancelledError } from './errors';
import { GoogleSocialLogin } from './google-provider';
import { clearOAuthPopupMarker, deliverOAuthResult, OAUTH_STATE_KEY, shouldAutoFinishOAuthRedirect, } from './oauth-popup-bridge';
import { OAuth2SocialLogin } from './oauth2-provider';
import { TelegramSocialLogin } from './telegram-provider';
import { TwitterSocialLogin } from './twitter-provider';
async function parseRedirectResult() {
    var _a;
    const url = new URL(window.location.href);
    const stateRaw = localStorage.getItem(OAUTH_STATE_KEY);
    let provider = null;
    let state;
    let nonce;
    if (stateRaw) {
        try {
            const parsed = JSON.parse(stateRaw);
            provider = (_a = parsed.provider) !== null && _a !== void 0 ? _a : null;
            state = parsed.state;
            nonce = parsed.nonce;
        }
        catch (_b) {
            provider = stateRaw === 'true' ? 'google' : null;
        }
    }
    const googleProvider = new GoogleSocialLogin();
    const oauth2Provider = new OAuth2SocialLogin();
    const twitterProvider = new TwitterSocialLogin();
    const telegramProvider = new TelegramSocialLogin();
    let result = null;
    switch (provider) {
        case 'twitter':
            result = await twitterProvider.handleOAuthRedirect(url, state);
            break;
        case 'telegram':
            result = await telegramProvider.handleOAuthRedirect(url, state);
            break;
        case 'oauth2':
            result = await oauth2Provider.handleOAuthRedirect(url, state);
            break;
        case 'google':
        default:
            result = googleProvider.handleOAuthRedirect(url);
            break;
    }
    return { provider, state, nonce, result };
}
function buildOAuthMessage(parsed) {
    const { result } = parsed;
    if (!result)
        return null;
    if ('error' in result) {
        const error = inferUserCancelledError(result.error);
        return Object.assign({ type: 'oauth-error', provider: parsed.provider, error: error.message }, (error.code ? { code: error.code } : null));
    }
    return Object.assign({ type: 'oauth-response', provider: result.provider }, result.result);
}
async function finishOAuthRedirectInPopup() {
    var _a, _b, _c, _d, _e;
    const parsed = await parseRedirectResult();
    const nonceOrState = (_a = parsed.nonce) !== null && _a !== void 0 ? _a : parsed.state;
    const message = buildOAuthMessage(parsed);
    if (!message) {
        // OAuth params may not be ready yet (SPA router). Retry briefly.
        if (shouldAutoFinishOAuthRedirect()) {
            await new Promise((resolve) => setTimeout(resolve, 100));
            const retryParsed = await parseRedirectResult();
            const retryMessage = buildOAuthMessage(retryParsed);
            if (retryMessage) {
                deliverOAuthResult((_b = retryParsed.provider) !== null && _b !== void 0 ? _b : 'google', (_c = retryParsed.nonce) !== null && _c !== void 0 ? _c : retryParsed.state, retryMessage);
            }
            else {
                deliverOAuthResult((_d = parsed.provider) !== null && _d !== void 0 ? _d : 'google', nonceOrState, {
                    type: 'oauth-error',
                    provider: parsed.provider,
                    error: 'OAuth redirect did not contain expected parameters.',
                });
            }
        }
    }
    else {
        deliverOAuthResult((_e = parsed.provider) !== null && _e !== void 0 ? _e : 'google', nonceOrState, message);
    }
    clearOAuthPopupMarker();
    try {
        window.close();
    }
    catch (_f) {
        // Popup may not be allowed to close itself in some contexts
    }
}
function onHashChange() {
    if (!shouldAutoFinishOAuthRedirect())
        return;
    void finishOAuthRedirectInPopup();
}
export function initOAuthPopupRedirectHandler() {
    if (typeof window === 'undefined')
        return;
    if (shouldAutoFinishOAuthRedirect()) {
        void finishOAuthRedirectInPopup();
    }
    // SPA routers may apply the OAuth hash after initial load
    window.addEventListener('hashchange', onHashChange);
}
// Auto-run on import so popup windows finish OAuth even before plugin lazy-load
initOAuthPopupRedirectHandler();
//# sourceMappingURL=oauth-popup-redirect.js.map